import Footer from "../Footer"
import prices from "../../data/prices"
import PricesItem from "../Main/PricesItem"
import PhoneButton from "../Main/PhoneButton"
import { Fade } from "@mui/material"
import timeout from "../../data/timeout"
import { logMessage } from "../../utils/utils"

const Prices = () => {
  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
  setTimeout(() => {
    scrollUp()
  }, 100)

  const today = new Date()

  return (
    <Fade timeout={timeout} in>
      <div className="pt-24 flex flex-col justify-between min-h-screen">
        <div className="text-3xl mb-2 text-[#002998ef]">Ціни на послуги:</div>
        <div className="text-md mb-10 text-black">
          {`(актуальні на ${today.toLocaleDateString()})`}
        </div>
        <div className="grow">
          <div className="max-w-[1110px] mx-auto border">
            {prices.map((item, i) => (
              <PricesItem key={i} item={item} />
            ))}
          </div>
          {/* <div className="px-2 text-2xl mt-10 text-[#002998ef]">
            {language
              ? "За додатковою інформацією звертайтесь за телефоном:"
              : "For more information please call:"}
          </div> */}

          {/* <div className="mt-12">
            <PhoneButton />
          </div> */}
        </div>

        {/* <div>
          <Footer language={language} />
        </div> */}
      </div>
    </Fade>
  )
}

export default Prices
